import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  TextField,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Srcs
import "../Style/pagestyle.scss";
// import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import FooterPagination from "../Components/Include/FooterPagination";
import { currencyFormat } from "../Function/DynamicFn";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import InvoiceAction from "../Components/Invoice/InvoiceAction";
import { GET_INVOICE_PAGEINATION } from "../Schema/Invoice";

export default function Invoice() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(true);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [keyword, setKeyword] = useState("");

  const { refetch } = useQuery(GET_INVOICE_PAGEINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      to: toDate === "" ? "" : moment(toDate).format("YYYY-MM-DD"),
      from: fromDate === "" ? "" : moment(fromDate).format("YYYY-MM-DD"),
    },
    onCompleted: ({ getInvoicePagination }) => {
      setTableData(getInvoicePagination?.data);
      setPaginationData(getInvoicePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
    setLoading(true);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, fromDate, toDate]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="invoice">
            <Typography className="page-title">{t("page_invoice")}</Typography>
          </Link>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              {t("page_invoice")}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              className="search-field"
              size="small"
              fullWidth
              placeholder="search"
              onChange={(e) => {
                setPage(1);
                setKeyword(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          {/* <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">Class</Typography>
            <FormControl className="select-date">
              <Select className="select-date" size="small">
                <MenuItem value={10}>Ten</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">
                N<sup>o</sup>
              </TableCell>
              <TableCell className="header-title">Recipt Number</TableCell>
              <TableCell className="header-title">Date</TableCell>
              <TableCell className="header-title">Student Name</TableCell>
              <TableCell className="header-title">Class</TableCell>
              {/* <TableCell className="header-title">Discount</TableCell> */}
              <TableCell className="header-title">Total Amount</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>


            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={8} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={8} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                row?.void
                                  ? "body-cell-start-void"
                                  : "body-cell-start"
                              }
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-void" : "body-cell"
                              }
                            >
                              {row?.inv}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-void" : "body-cell"
                              }
                            >
                              {moment(row?.date).format("DD-MM-yyyy")}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-void" : "body-cell"
                              }
                            >
                              {row?.studentInfo?.fullName}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-void" : "body-cell"
                              }
                            >
                              {row?.studentInfo?.grade}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void ? "body-cell-void" : "body-cell"
                              }
                            >
                              $ {currencyFormat(row?.total)}
                            </TableCell>
                            <TableCell
                              className={
                                row?.void
                                  ? "body-cell-end-void"
                                  : "body-cell-end"
                              }
                            >
                              <InvoiceAction editData={row} />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )
            }
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
